<div class="twodatablock">
  <div class="datablock">
    <div class="inputgroup">
      <label>{{'User'|translate}}:</label>
      <input class="readonly" type="text" readonly="readonly" [ngModel]="GetCurrentUserName()" />
    </div>
    <app-entities-list [entities]="myEntities" [filterentities]="targetEntities" [deletedOnly]="true" [company]="currentCompany" [companies]="companies"
      [IsCopyControl]="IsCopyControl" (onDeleteClicked)="stopSharingWithCurrentUser($event)">
    </app-entities-list>
    <div class="manipulation-controls">
      <div class="left_block">
        <button class="btn_del" (click)="deleteFromCurrentUser()" title="{{'Delete'|translate}}"></button>
      </div>
    </div>
  </div>
  <div class="vertseparator"></div>
  <div class="datablock">
    <div class="inputgroup">
      <label>{{'Company'|translate}}:</label>
      <div style="display: flex;">
        <select class="company-select" [(ngModel)]="selectedCompanyId" (ngModelChange)="FillTargetEntities()">
          <option *ngFor="let company of companies" value="{{company.Id}}">
            {{company.Name}}
          </option>
        </select>
      </div>
    </div>
    <app-entities-list *ngIf="targetUser != undefined" [entities]="targetEntities" [filterentities]="myEntities"
       [IsCopyControl]="IsCopyControl"  [company]="GetTargetCompany()" [companies]="companies"
      (onDeleteClicked)="stopSharingWithTargetUser($event)">
    </app-entities-list>
    <div class="manipulation-controls">
      <div class="left_block">
        <button class="btn_del" (click)="deleteFromTargetUser()" title="{{'Delete'|translate}}"></button>

        <button class="btn_userleft" (click)="shareWithCurrentUser()">{{'Share objects'|translate}}</button>
      </div>
    </div>
  </div>
</div>
